import { useEffect, useState } from "react";
import type { Widget } from "../../widgets/types";
import type { DashboardDocument } from "./copy";

const CHARTS = new Set(["line_chart", "bar_chart"]);

/** The document's widgets in reading order, charts without a range taking the dashboard's (DSH-01, DSH-02). */
export function dashboardWidgets(doc: DashboardDocument): Widget[] {
  return [...doc.widgets]
    .sort((a, b) => a.position.y - b.position.y || a.position.x - b.position.x)
    .map((w) => {
      const config = (w.config ?? {}) as Record<string, unknown>;
      return CHARTS.has(w.type) && doc.time_range && typeof config.range !== "string"
        ? { ...w, config: { ...config, range: doc.time_range } }
        : { ...w, config };
    });
}

/** The live clock the widgets' ages count from. */
export function useNow(everyMs = 30_000) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), everyMs);
    return () => clearInterval(id);
  }, [everyMs]);
  return now;
}
